import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.5.147a.93.93 0 0 0-1 0L16 3.863 8.4.147h-.1C8.2.05 8.1.05 8 .05s-.2 0-.4.097h-.2l-7 3.91c-.2.196-.4.49-.4.88v15.642c0 .39.2.684.5.88s.7.195 1 0L8 17.743l7.5 3.715c.2.098.3.098.5.098.1 0 .2 0 .3-.098h.2l7-3.91c.3-.196.5-.49.5-.88V1.027c0-.39-.2-.684-.5-.88M9 2.59l6 2.933v13.49l-6-2.931V2.59M2 5.524l5-2.835v13.394l-5 2.835zm20 10.559-5 2.835V5.524l5-2.835z"
    }, null, -1)
  ]))]))
}
export default { render: render }